import React from "react";
import PropTypes from "prop-types";
import { Row, Spin, Icon } from "antd";
import { get } from "lodash";
import { Lib, CheckPermission } from "App/Utils";
import SubAllList from "App/Component/SubAllList";
import descriptor from "./descriptorOffline";

class PageExportMapping extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isGettingPermissions: true,
      permissionItems: [],
    }
  }

  getPermissions = () => {
    const permissionItems = CheckPermission.getPermissionSet({
      userReducer: this.props.userReducer,
      appName: 'estimation',
      modelName: 'exportmapping',
    }).filter(perm => !perm.includes('.delete_'))
    this.setState({ isGettingPermissions: false, permissionItems })
  }

  onAddExportMapping = () => {
    const { merchant } = this.props
    const historyState = {
      dataIdentifier: {
        merchant: { pk: merchant.pk, name: merchant.name }
      }
    }
    Lib.historyAction(this.props.history, '/admin/estimation/export-mappings/add', historyState).push()
  }

  onDetailExportMapping = (id) => {
    Lib.historyAction(this.props.history, `/admin/estimation/export-mappings/${id}`).push()
  }

  componentDidMount() {
    this.getPermissions()
  }

  componentWillUnmount() {
    Lib.windowStop();
  }

  render() {
    const { userReducer, match } = this.props
    const { isGettingPermissions, permissionItems } = this.state

    return isGettingPermissions ? (
      <Row type='flex' justify='center' align='middle' style={{ margin: '30vh 0' }}>
        <Spin
          size='large'
          tip='Loading...'
          indicator={<Icon spin type='loading' style={{ fontSize: '4rem' }} />}
        />
      </Row>
    ) : (
      <SubAllList
        permissions={permissionItems}
        pageTitle="Export Mapping"
        avatar="product.name"
        descriptor={descriptor}
        masterKey="module-merchant-merchant-refExportMapping"
        args={[get(match, 'params.id')]}
        onAddClick={this.onAddExportMapping}
        onDetailClick={this.onDetailExportMapping}
        userReducer={userReducer}
      />
    );
  }
}

PageExportMapping.propTypes = {
  userReducer: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  merchant: PropTypes.object.isRequired,
}

PageExportMapping.defaultProps = {
  permissionItems: [],
}

export default PageExportMapping;
